import React, { ReactNode } from 'react';

import { CardImageLoading } from '../CardImageLoading';

type TCardImageProps = {
  value: string;
  children: ReactNode;
};

export const CardImageExternal = ({ value, children }: TCardImageProps) => {
  return (
    <div className="vitrine-template2__card--image">
      {!value ? (
        <CardImageLoading />
      ) : (
        <div className="vitrine-template2__card--image-external">
          <img key={`id-${value}`} src={value} alt="" />
        </div>
      )}
      {children}
    </div>
  );
};
